import { render, staticRenderFns } from "./KOLReports.vue?vue&type=template&id=774ce31d&"
import script from "./KOLReports.vue?vue&type=script&lang=js&"
export * from "./KOLReports.vue?vue&type=script&lang=js&"
import style0 from "./KOLReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports